import * as React from "react";
import { ViewProps, TextProps as RNTextProps } from "react-native";
import { Box, Text } from "@/components/ui/primitives";
import { BoxProps, TextProps } from "@/lib/styling";

type CardProps = BoxProps & ViewProps;
type CardTextProps = TextProps & RNTextProps;

// Card
const Card = React.forwardRef<any, CardProps>(
  ({ style, ...props }, ref) => (
    <Box
      ref={ref}
      backgroundColor="surface"
      borderRadius="m"
      borderWidth={1}
      borderColor="border"
      shadowColor="transparent"
      shadowOpacity={0}
      shadowOffset={{ width: 0, height: 0 }}
      shadowRadius={0}
      elevation={0}
      style={style}
      {...props}
    />
  )
);
Card.displayName = "Card";

// CardHeader
const CardHeader = React.forwardRef<any, CardProps>(
  ({ style, children, ...props }, ref) => (
    <Box
      ref={ref}
      flexDirection="column"
      padding="l"
      gap="s"
      style={style}
      {...props}
    >
      {children}
    </Box>
  )
);
CardHeader.displayName = "CardHeader";

// CardTitle
const CardTitle = React.forwardRef<any, CardTextProps>(
  ({ style, ...props }, ref) => (
    <Text
      ref={ref}
      variant="title"
      textTransform="uppercase"
      style={style}
      {...props}
    />
  )
);
CardTitle.displayName = "CardTitle";

// CardDescription
const CardDescription = React.forwardRef<any, CardTextProps>(
  ({ style, ...props }, ref) => (
    <Text
      ref={ref}
      variant="bodySmall"
      color="pressMuted"
      style={style}
      {...props}
    />
  )
);
CardDescription.displayName = "CardDescription";

// CardContent
const CardContent = React.forwardRef<any, CardProps>(
  ({ style, ...props }, ref) => (
    <Box
      ref={ref}
      padding="l"
      paddingTop="none"
      style={style}
      {...props}
    />
  )
);
CardContent.displayName = "CardContent";

// CardFooter
const CardFooter = React.forwardRef<any, CardProps>(
  ({ style, ...props }, ref) => (
    <Box
      ref={ref}
      padding="l"
      paddingTop="none"
      flexDirection="row"
      alignItems="center"
      style={style}
      {...props}
    />
  )
);
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
